import React from "react";

import Spacer from "./spacer";

class SpacerContainer extends React.Component {
  render() {
    return <Spacer />;
  }
}
export default SpacerContainer;
